import { Injectable } from '@angular/core';
import { apiEndPoints } from 'src/app/common/constants/api-endpointsconstant';
import { ApiService } from 'src/app/common/services/api.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WarehousePropertyDetailService {
 
  constructor(
    private reportService: ReportService,
    private apiServive: ApiService
  ) {}

  /**
   * Fetches warehouse property detail data based on the provided payload and property UID.
   * @param propertyUid - Unique identifier for the property.
   * @returns Observable with the warehouse property detail data.
   */
  getWarehousePropertyDetail(propertyUid: any) {
    // Clone current report query parameters
    let queryParams = { ...this.reportService.queryParams};
    // Set the year if year is selected if not then set current year in queryParams, prioritizing payload or using max year from reportService
  // if (queryParams?.year) {
  //     queryParams.year = this.reportService.yearMaxValue(queryParams.year);
  //   } else {
  //     if(queryParams?.transaction_date) {
  //       queryParams['year'] = this.reportService.getTTMmaxYear(queryParams?.transaction_date);
  //     } else {
  //       queryParams['year'] = new Date().getFullYear();
  //     }
  //   }
    // Generate filter query string using ReportService utility
    // const changeParams = this.reportService.setfilterQueryParams(queryParams);
    // Build the API endpoint URL for fetching property details
    let url: string = `${environment.miUrl}${apiEndPoints.propertyDetailWarehouseUnitSize}?property_uid=${propertyUid}&report_id=${queryParams.rid}`;
    // Make GET request to fetch the data
    return this.apiServive.get(url, false);
  }
}